export const getUniqueKey = (item: OptionChainRowData) => {
  const { token, strike, exchangeToken } = item;
  return token ? exchangeToken : strike;
};
